import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaFire, FaFileAlt, FaUsers, FaHeart, FaDove, FaCloudRain, FaVideo } from 'react-icons/fa';
import estrutura01 from "../assets/images/hero-bg.jpg";

const CremacaoContainer = styled.div`
  color: var(--primary-blue);
  padding-top: 80px;
  min-height: 100vh;
  @media screen and (max-width: 768px) {
    padding-top: 40px;
  }
`;

const CremacaoWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px 40px 24px;
`;

const TopLine = styled(motion.p)`
  color: #4CAF50;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
  font-family: 'Open Sans', sans-serif;
`;

const Heading = styled(motion.h1)`
  margin-bottom: 24px;
  font-size: 48px;
  font-weight: 600;
  color: var(--primary-blue);
  font-family: 'Playfair Display', serif;
  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

const Subtitle = styled(motion.p)`
  max-width: 700px;
  margin-bottom: 60px;
  font-size: 18px;
  line-height: 24px;
  color: var(--primary-blue);
  font-family: 'Open Sans', sans-serif;
`;

const SectionWrapper = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background: ${({ $even }) => $even ? '#fff' : 'var(--primary-blue)'};
  transition: background 0.3s;
`;

const Section = styled(motion.section)`
  margin-bottom: 0;
  padding: 40px 0;
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 30px;
  color: ${({ $even }) => $even ? 'var(--primary-blue)' : '#fff'};
  font-family: 'Playfair Display', serif;
  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const SectionContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
  
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const SectionText = styled.div`
  color: ${({ $even }) => $even ? 'var(--primary-blue)' : '#fff'};
`;

const SectionDesc = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: ${({ $even }) => $even ? 'var(--primary-blue)' : '#fff'};
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 20px;
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0;
`;

const FeatureItem = styled.li`
  font-size: 1rem;
  line-height: 1.6;
  color: ${({ $even }) => $even ? 'var(--primary-blue)' : '#fff'};
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
  
  &:before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #4CAF50;
    font-weight: bold;
  }
`;

const IconSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: #4CAF50;
  margin-bottom: 20px;
`;

const DocumentSection = styled.div`
  background: #f8f9fa;
  border-radius: 15px;
  padding: 30px;
  margin-bottom: 30px;
  border-left: 5px solid #4CAF50;
`;

const DocumentTitle = styled.h3`
  font-size: 1.5rem;
  color: var(--primary-blue);
  margin-bottom: 20px;
  font-family: 'Playfair Display', serif;
`;

const DocumentList = styled.ul`
  list-style: none;
  padding: 0;
`;

const DocumentItem = styled.li`
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
  
  &:before {
    content: '•';
    position: absolute;
    left: 0;
    color: #4CAF50;
    font-weight: bold;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const ServiceCard = styled(motion.div)`
  background: ${({ $even }) => $even ? '#fff' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-top: 5px solid #4CAF50;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
`;

const ServiceIcon = styled.div`
      width: 80px;
    height: 80px;
    background: var(--primary-blue);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    color: #fff;
    font-size: 2rem;
`;

const ServiceTitle = styled.h3`
  font-size: 1.3rem;
  color: ${({ $even }) => $even ? 'var(--primary-blue)' : '#fff'};
  margin-bottom: 15px;
  font-family: 'Playfair Display', serif;
`;

const ServiceDesc = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: ${({ $even }) => $even ? '#333' : '#fff'};
  font-family: 'Open Sans', sans-serif;
`;

const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 20px 0;
`;

const Button = styled(motion.button)`
  border-radius: 4px;
  background: #4CAF50;
  padding: 12px 30px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #4CAF50;
  }
`;

const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

const ImgGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  max-width: 555px;
`;

const Img = styled(motion.img)`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
`;

const Cremacao = () => {
  return (
    <CremacaoContainer>
      <CremacaoWrapper>
        <TopLine
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Cremação
        </TopLine>
        <Heading
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Tecnologia Moderna e Respeito à Tradição
        </Heading>
        <Subtitle
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          O Crematório Dom José possui um dos mais modernos sistemas do Brasil para o Processo de Cremação. 
          Entre em contato conosco e saiba mais sobre nossos planos de Cremação.
        </Subtitle>

        {/* Sobre a Cremação */}
        <SectionWrapper $even={true} style={{marginTop: -50}}>
          <Section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <SectionTitle $even={true}>História da Cremação</SectionTitle>
            <SectionContent>
              <SectionText $even={true}>
                <SectionDesc $even={true}>
                  A cremação é um dos processos mais antigos praticados pelo homem. Em algumas sociedades este costume era considerado corriqueiro e fazia parte do cotidiano da população, por se tratar de uma medida prática e higiênica.
                </SectionDesc>
                <SectionDesc $even={true}>
                  Alguns povos utilizavam a cremação para rituais fúnebres: os gregos, por exemplo, cremavam seus cadáveres por volta de 1.000 A.C. e os romanos, seguindo a mesma lista de tradição, adotaram a prática por volta do ano 750 A.C.
                </SectionDesc>
                <SectionDesc $even={true}>
                  No Japão, a cremação foi adotada com o advento do Budismo, em 552 D.C, importado da China. Como em outras localidades, ela foi aceita primeiramente pela aristocracia e a seguir pelo povo.
                </SectionDesc>
              </SectionText>
              <ImgWrap>
                <ImgGrid>
                    <Img
                    src={estrutura01}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    />
                </ImgGrid>
            </ImgWrap>

            </SectionContent>
          </Section>
        </SectionWrapper>

        {/* Documentação Necessária */}
        <SectionWrapper $even={false}>
          <Section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <TopLine
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                Documentos
            </TopLine>
            <SectionTitle $even={false}>Documentação Necessária</SectionTitle>
            <SectionContent>
                <SectionText $even={false}>
                    <SectionDesc $even={false}>
                        Para ser cremado, o corpo precisa estar acompanhado de alguns documentos.
                    </SectionDesc>
                    <SectionDesc $even={false}>
                        A lista de documentos está especificado nos cards "Falecimento por Morte Natural" e "Falecimento por Morte Violenta/Trágica"
                    </SectionDesc>
                    <SectionDesc $even={false}>
                        O documento de Autorização para Cremação, deverá ser preenchida por 02 (dois) familiares mais próximos.
                    </SectionDesc>
                    <SectionDesc $even={false}>
                        O documento de Autorização para Cremação está disponível para download no botão abaixo:
                    </SectionDesc>
                    <BtnWrap>
                        <Button
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 1 }}
                            onClick={() => window.open('http://www.crematoriodomjose.com.br/documentos/autorizacao_cremacao.pdf', '_Blank')}

                        >
                            Baixar documento de Autorização para Cremação
                        </Button>
                    </BtnWrap>
                    <SectionDesc $even={false}>
                        Em caso de dúvidas, entre em contato para que possamos lhe auxiliar.
                    </SectionDesc>    
                    

                </SectionText>
                <div>
                    <DocumentSection>
                        <DocumentTitle>Falecimento por Morte Natural</DocumentTitle>
                        <DocumentList>
                            <DocumentItem>Declaração de óbito: ORIGINAL OU CÓPIA AUTENTICADA - deverá ser assinada por 02 (dois) médicos</DocumentItem>
                            <DocumentItem>No espaço "SEPULTAMENTO", deverá constar MEMORIAL CREMATÓRIO DOM JOSE - Santa Rosa/RS</DocumentItem>
                            <DocumentItem>AUTORIZAÇÃO PARA O PROCESSO DE CREMAÇÃO: - Deverá ser preenchida por 02 (dois) familiares mais próximos</DocumentItem>
                            <DocumentItem>Cópia simples de CPF e RG dos autorizantes</DocumentItem>
                        </DocumentList>
                    </DocumentSection>
                    <DocumentSection>
                        <DocumentTitle>Falecimento por Morte Violenta/Trágica</DocumentTitle>
                        <DocumentList>
                            <DocumentItem>Mesma documentação (Morte Natural) e ainda:</DocumentItem>
                            <DocumentItem>Autorização Judicial - o Juiz deverá assinar uma autorização informando que não se opõe à cremação</DocumentItem>
                        </DocumentList>
                    </DocumentSection>
                </div>


                
              
            </SectionContent>
            
          </Section>
        </SectionWrapper>

        {/* Serviços Especiais */}
        <SectionWrapper $even={true}>
          <Section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <SectionTitle $even={true}>Serviços Especiais</SectionTitle>
            <ServicesGrid>
              {/*<ServiceCard
                $even={true}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <ServiceIcon>
                  <FaVideo />
                </ServiceIcon>
                <ServiceTitle $even={true}>Velório Online</ServiceTitle>
                <ServiceDesc $even={true}>
                  Disponibilizamos o VELÓRIO ONLINE para familiares que não podem acompanhar a cerimônia de forma presencial. 
                  Mediante autorização dos familiares disponibilizamos o usuário e a senha.
                </ServiceDesc>
              </ServiceCard>*/}

              <ServiceCard
                $even={true}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <ServiceIcon>
                  <FaHeart />
                </ServiceIcon>
                <ServiceTitle $even={true}>Homenagem</ServiceTitle>
                <ServiceDesc $even={true}>
                  Disponibilizamos aos familiares uma homenagem do ente querido. 
                  Para isso, familiares deverão encaminhar fotos com antecedência ou entregar na funerária.
                </ServiceDesc>
              </ServiceCard>

              <ServiceCard
                $even={true}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <ServiceIcon>
                  <FaCloudRain />
                </ServiceIcon>
                <ServiceTitle $even={true}>Chuva de Pétalas</ServiceTitle>
                <ServiceDesc $even={true}>
                  Ao final da Cerimônia os familiares acompanham uma chuva de pétalas sobre a Urna, 
                  proporcionando um momento de beleza e despedida.
                </ServiceDesc>
              </ServiceCard>

              <ServiceCard
                $even={true}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
              >
                <ServiceIcon>
                  <FaDove />
                </ServiceIcon>
                <ServiceTitle $even={true}>Revoamento de Pombos</ServiceTitle>
                <ServiceDesc $even={true}>
                  Em homenagem ao Ente Querido, os familiares acompanham o revoamento de pombos brancos. 
                  Obs: o revoamento de pombos acontece somente nas Cerimônias realizadas até as 18h.
                </ServiceDesc>
              </ServiceCard>
            </ServicesGrid>
          </Section>
        </SectionWrapper>

        {/* Informações de Contato 
        <SectionWrapper $even={false}>
          <Section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <SectionTitle $even={false}>Entre em Contato</SectionTitle>
            <SectionContent>
              <SectionText $even={false}>
                <SectionDesc $even={false}>
                  Para mais informações sobre nossos serviços de cremação, entre em contato conosco:
                </SectionDesc>
                <FeaturesList $even={false}>
                  <FeatureItem $even={false}>
                    <strong>Endereço:</strong> ERS 162, N 2191, no Bairro Auxiliadora - Santa Rosa - RS
                  </FeatureItem>
                  <FeatureItem $even={false}>
                    <strong>Telefone:</strong> (55) 3512 2727
                  </FeatureItem>
                  <FeatureItem $even={false}>
                    <strong>Email:</strong> crematorio@crematoriodomjose.com.br
                  </FeatureItem>
                </FeaturesList>
              </SectionText>
              <IconSection>
                <FaUsers />
              </IconSection>
            </SectionContent>
          </Section>
        </SectionWrapper>*/}
        
      </CremacaoWrapper>
    </CremacaoContainer>
  );
};

export default Cremacao; 